// extracted by mini-css-extract-plugin
module.exports = {"title":"c5eaR-t","brandLink":"TPCOgT","brandImage":"xNg3Qb","brandRedirectText":"J0Rh0C","body":"VIKhiM","readMore":"XFkVl8"};